export enum PageViewPNF {
  REPORT = 'report',
  RETRACT = 'retract'
}

export const SIGNIN_PAGE_URL_TO_PAGE_VIEW_MAP: Record<string, PageViewPNF> = {
  '/report/infringement/retract/signin': PageViewPNF.RETRACT,
  '/report/infringement/signin': PageViewPNF.REPORT,
};

export const getPageViewForSignInPageUrl = (url: string): string => SIGNIN_PAGE_URL_TO_PAGE_VIEW_MAP[url];

export const LANDING_PAGE_URL_TO_PAGE_VIEW_MAP: Record<string, PageViewPNF> = {
  '/report/infringement': PageViewPNF.REPORT,
  '/report/infringement/retract': PageViewPNF.RETRACT,
};

export const getPageViewForLandingPageUrl = (url: string): string => LANDING_PAGE_URL_TO_PAGE_VIEW_MAP[url];

export enum CountryCode {
  AE = 'AE',
  AU = 'AU',
  BE = 'BE',
  BR = 'BR',
  CA = 'CA',
  CL = 'CL',
  CN = 'CN',
  CO = 'CO',
  DE = 'DE',
  EG = 'EG',
  ES = 'ES',
  FR = 'FR',
  GB = 'GB',
  IN = 'IN',
  IT = 'IT',
  JP = 'JP',
  MX = 'MX',
  NG = 'NG',
  NL = 'NL',
  PL = 'PL',
  SA = 'SA',
  SE = 'SE',
  SG = 'SG',
  TR = 'TR',
  US = 'US',
  ZA = 'ZA'
}

const BRAND_REGISTRY_ENROLL_URLS: Record<CountryCode, string> = {
  AE: 'https://brandservices.amazon.ae/brandregistry/eligibility?ref=BRAENF&ld=BRAENF',
  AU: 'https://brandservices.amazon.com.au/brandregistry/eligibility?ref=BRAUNF&ld=BRAUNF',
  BE: 'https://brandservices.amazon.com.be/brandregistry/eligibility?ref=BRBENF&ld=BRBENF',
  BR: 'https://brandservices.amazon.com.br/brandregistry/eligibility?ref=BRBRNF&ld=BRBRNF',
  CA: 'https://brandservices.amazon.ca/brandregistry/eligibility?ref=BRCANF&ld=BRCANF',
  CL: 'https://brandservices.amazon.cl/brandregistry/eligibility?ref=BRCLNF&ld=BRCLNF',
  CN: 'https://brandservices.amazon.com/brandregistry/eligibility?ref=BRCNNF&ld=BRCNNF',
  CO: 'https://brandservices.amazon.com.co/brandregistry/eligibility?ref=BRCLOF&ld=BRCONF',
  DE: 'https://brandservices.amazon.de/brandregistry/eligibility?ref=BRDENF&ld=BRDENF',
  EG: 'https://brandservices.amazon.eg/brandregistry/eligibility?ref=BREGNF&ld=BREDNF',
  ES: 'https://brandservices.amazon.es/brandregistry/eligibility?ref=BRESNF&ld=BRESNF',
  FR: 'https://brandservices.amazon.fr/brandregistry/eligibility?ref=BRFRNF&ld=BRFRNF',
  GB: 'https://brandservices.amazon.co.uk/brandregistry/eligibility?ref=BRUKNF&ld=BRUKNF',
  IN: 'https://brandservices.amazon.in/brandregistry/eligibility?ref=BRINNF&ld=BRINNF',
  IT: 'https://brandservices.amazon.it/brandregistry/eligibility?ref=BRITNF&ld=BRITNF',
  JP: 'https://brandservices.amazon.co.jp/brandregistry/eligibility?ref=BRJPNF&ld=BRJPNF',
  MX: 'https://brandservices.amazon.com.mx/brandregistry/eligibility?ref=BRMXNF&ld=BRMXNF',
  NG: 'https://brandservices.amazon.com.ng/brandregistry/eligibility?ref=BRNGNF&ld=BRNGNF',
  NL: 'https://brandservices.amazon.nl/brandregistry/eligibility?ref=BRNLNF&ld=BRNLNF',
  PL: 'https://brandservices.amazon.pl/brandregistry/eligibility?ref=BRPLNF&ld=BRPLNF',
  SA: 'https://brandservices.amazon.sa/brandregistry/eligibility?ref=BRSANF&ld=BRSANF',
  SE: 'https://brandservices.amazon.se/brandregistry/eligibility?ref=BRSENF&ld=BRSENF',
  SG: 'https://brandservices.amazon.sg/brandregistry/eligibility?ref=BRSGNF&ld=BRSGNF',
  TR: 'https://brandservices.amazon.com.tr/brandregistry/eligibility?ref=BRTRNF&ld=BRTRNF',
  US: 'https://brandservices.amazon.com/brandregistry/eligibility?ref=BRUSNF&ld=BRUSNF',
  ZA: 'https://brandservices.amazon.co.za/brandregistry/eligibility?ref=BRZANF&ld=BRZANF',
};

export const getBREnrollUrl = (countryCode: CountryCode): string => BRAND_REGISTRY_ENROLL_URLS[countryCode];

const BRAND_REGISTRY_URLS: Record<CountryCode, string> = {
  AE: 'https://brandservices.amazon.ae/brandregistry?ref=BRAENF&ld=BRAENF',
  AU: 'https://brandservices.amazon.com.au/brandregistry?ref=BRAUNF&ld=BRAUNF',
  BE: 'https://brandservices.amazon.com.be/brandregistry?ref=BRBENF&ld=BRBENF',
  BR: 'https://brandservices.amazon.com.br/brandregistry?ref=BRBRNF&ld=BRBRNF',
  CA: 'https://brandservices.amazon.ca/brandregistry?ref=BRCANF&ld=BRCANF',
  CL: 'https://brandservices.amazon.cl/brandregistry?ref=BRCLNF&ld=BRCLNF',
  CN: 'https://brandservices.amazon.com/brandregistry?ref=BRCNNF&ld=BRCNNF',
  CO: 'https://brandservices.amazon.com.co/brandregistry?ref=BRCLOF&ld=BRCONF',
  DE: 'https://brandservices.amazon.de/brandregistry?ref=BRDENF&ld=BRDENF',
  EG: 'https://brandservices.amazon.eg/brandregistry?ref=BREGNF&ld=BREDNF',
  ES: 'https://brandservices.amazon.es/brandregistry?ref=BRESNF&ld=BRESNF',
  FR: 'https://brandservices.amazon.fr/brandregistry?ref=BRFRNF&ld=BRFRNF',
  GB: 'https://brandservices.amazon.co.uk/brandregistry?ref=BRUKNF&ld=BRUKNF',
  IN: 'https://brandservices.amazon.in/brandregistry?ref=BRINNF&ld=BRINNF',
  IT: 'https://brandservices.amazon.it/brandregistry?ref=BRITNF&ld=BRITNF',
  JP: 'https://brandservices.amazon.co.jp/brandregistry?ref=BRJPNF&ld=BRJPNF',
  MX: 'https://brandservices.amazon.com.mx/brandregistry?ref=BRMXNF&ld=BRMXNF',
  NG: 'https://brandservices.amazon.com.ng/brandregistry?ref=BRNGNF&ld=BRNGNF',
  NL: 'https://brandservices.amazon.nl/brandregistry?ref=BRNLNF&ld=BRNLNF',
  PL: 'https://brandservices.amazon.pl/brandregistry?ref=BRPLNF&ld=BRPLNF',
  SA: 'https://brandservices.amazon.sa/brandregistry?ref=BRSANF&ld=BRSANF',
  SE: 'https://brandservices.amazon.se/brandregistry?ref=BRSENF&ld=BRSENF',
  SG: 'https://brandservices.amazon.sg/brandregistry?ref=BRSGNF&ld=BRSGNF',
  TR: 'https://brandservices.amazon.com.tr/brandregistry?ref=BRTRNF&ld=BRTRNF',
  US: 'https://brandservices.amazon.com/brandregistry?ref=BRUSNF&ld=BRUSNF',
  ZA: 'https://brandservices.amazon.co.za/brandregistry?ref=BRZANF&ld=BRZANF',
};

export const getBRUrl = (countryCode: CountryCode): string => BRAND_REGISTRY_URLS[countryCode];
